export default __webpack_public_path__ + "static/media/demoIceHockeyPlayer.619512a5.png";